<template>
    <div class="password-new-body" v-loading.fullscreen.lock="is_loading">
        <div class="password-new-area">
            <h4 class="content-sub-title">{{ $t('attributes.password_new_title')}}</h4>
            <!-- パスワード再設定 パスワード入力 説明書き -->
            <div class="password-new-description" v-html="$t('attributes.password_new_description')" />
                <div class="annotation-block annotation-block-lineheight">
                    {{ $t('attributes.password_explanation1') }}<br />
                    {{ $t('attributes.password_explanation2') }}
                </div>
            <div class="password-new-form">
                <el-form @submit.native.prevent="onReset" ref="password_form" :rules="rules" :model="password_form">
                    <el-form-item :label="$t('attributes.new_password')" prop="new_password">
                        <el-input class="input-text-free" clearable v-model="password_form.new_password" ref="new_password" />
                    </el-form-item>
                    <el-form-item :label="$t('attributes.re_enter')" prop="re_enter">
                        <el-input class="input-text-free" clearable v-model="password_form.re_enter" ref="re_enter" />
                    </el-form-item>
                </el-form>

                <el-row class="flex" :key="'is_length_valid_' + is_length_valid">
                    <span :class="is_length_valid ? 'green-area' : 'red-area'">
                        <i v-if="is_length_valid" class="far fa-check-circle" aria-hidden="true"></i>
                        <i v-else class="far fa-times-circle" aria-hidden="true"></i>
                        {{ $t('attributes.password_length') }}
                    </span>
                </el-row>

                <el-row class="flex" :key="'password_requires_upper_and_lower_case_' + password_requires_upper_and_lower_case">
                    <div :class="password_requires_upper_and_lower_case ? 'green-area' : 'red-area'">
                        <i v-if="password_requires_upper_and_lower_case" class="far fa-check-circle" aria-hidden="true"></i>
                        <i v-else class="far fa-times-circle" aria-hidden="true"></i>
                        {{ $t('attributes.password_requires_upper_and_lower_case') }}
                    </div>
                </el-row>

                <el-row class="flex" :key="'password_requires_number_and_specialchar_' + password_requires_number_and_specialchar">
                    <div :class="password_requires_number_and_specialchar ? 'green-area' : 'red-area'">
                        <i v-if="password_requires_number_and_specialchar" class="far fa-check-circle" aria-hidden="true"></i>
                        <i v-else class="far fa-times-circle" aria-hidden="true"></i>
                        {{ $t('attributes.password_requires_number_and_specialchar') }}
                    </div>
                </el-row>
            </div>
            <div class="button-block">
                <el-button type="primary" @click="onReset">{{ $t("attributes.send") }}</el-button>
                <el-button @click="onBack">{{ $t('attributes.back_to_login') }}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        //　パスワードが条件を満たすかチェック
        let passwordFormat = (rules, value, callback) => {
            let password = this.password_form.new_password;
            if (password.length === 0) {
                callback();
            } else {
                // すべての条件を満たしているか確認
                if (this.is_length_valid && this.password_requires_upper_and_lower_case && this.password_requires_number_and_specialchar) {
                    callback();
                } else {
                    callback(
                        new Error(
                            this.$t('attributes.password_format_error')
                        )
                    );
                }
            }
        };

        const isMatchPassword = (rule, value, callback) => {
            if (this.password_form.new_password == this.password_form.re_enter) {
                this.$refs.password_form.clearValidate('new_password');
                this.$refs.password_form.clearValidate('re_enter');
                callback()
                return
            }

            callback(
                new Error(
                    this.$t('attributes.mis_match_password_error')
                )
            );

            return;
        };
        return {
            is_loading: false,
            password_form: {
                new_password: '',
                re_enter: '',
            },
            rules: {
                new_password: [
                    {
                        validator: passwordFormat,
                        trigger: 'blur'
                    }
                ],
                re_enter: [
                    {
                        validator: isMatchPassword,
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    computed: {
        is_length_valid() {
            return this.password_form.new_password.length >= 10 && this.password_form.new_password.length <= 50;
        },
        // 英大文字と小文字を使用
        password_requires_upper_and_lower_case() {
            return /[a-z]/.test(this.password_form.new_password) && /[A-Z]/.test(this.password_form.new_password)
        },
        // 数字と記号を使用
        password_requires_number_and_specialchar() {
            return /[0-9]/.test(this.password_form.new_password) && /[-!"#$%&()*,./:;?@[\]^_`{|}~+<=>]/.test(this.password_form.new_password)
        },
    },
    methods: {
        onReset() {
            // パスワード リセット処理
            this.$refs['password_form'].validate(valid => {
                if (valid) {
                    this.is_loading = true;

                    const params = {
                        new_password: this.password_form.new_password,
                        re_enter: this.password_form.re_enter
                    }

                    // 新規ユーザーパスワード登録・パスワード強制変更と共通URL
                    axios
                        .post(`/api/password/reissue/reset/${this.$route.params.token}`, params)
                        .then(response => {
                            this.$message.success({ showClose: true, message: this.$t('attributes.other.update_succeeded') });
                            this.$refs.password_form.newFields();
                        })
                        .catch(error => {
                            this.$message.error({ showClose: true, message: error.response.data.message });
                        })
                        .finally(() => this.is_loading = false);
                }
            });
        },
        onBack() {
            this.$router.push({ name: 'login' });
        }
    }
};
</script>
